import request from '@/utils/request'

export function getWorkforceCostDashboardOverview () {
  return request({
    url: '/addon/workforceCostDashboard/overview',
    method: 'get'
  })
}
